import axios from 'axios';
import {
  COMPANY_LIST_REQUEST,
  COMPANY_LIST_SUCCESS,
  COMPANY_LIST_FAIL,
  COMPANY_CREATE_REQUEST,
  COMPANY_CREATE_SUCCESS,
  COMPANY_CREATE_FAIL,
  COMPANY_DETAILS_REQUEST,
  COMPANY_DETAILS_SUCCESS,
  COMPANY_DETAILS_FAIL,
  COMPANY_UPDATE_REQUEST,
  COMPANY_UPDATE_SUCCESS,
  COMPANY_UPDATE_FAIL,
  COMPANY_DELETE_REQUEST,
  COMPANY_DELETE_SUCCESS,
  COMPANY_DELETE_FAIL,
  COMPANY_TOGGLE_STATUS_REQUEST,
  COMPANY_TOGGLE_STATUS_SUCCESS,
  COMPANY_TOGGLE_STATUS_FAIL,
  COMPANY_STATS_REQUEST,
  COMPANY_STATS_SUCCESS,
  COMPANY_STATS_FAIL
} from '../constants/companyConstants';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Get all active companies (simple list for dropdowns)
export const listActiveCompanies = () => async (dispatch, getState) => {
  try {
    dispatch({ type: COMPANY_LIST_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(
      `${API_URL}/company?isActive=true&limit=1000`,
      config
    );

    dispatch({
      type: COMPANY_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: COMPANY_LIST_FAIL,
      payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message,
    });
  }
};

// Get all companies
export const listCompanies = (search = '', page = 1, limit = 50, isActive = '') => async (dispatch, getState) => {
  try {
    dispatch({ type: COMPANY_LIST_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(
      `${API_URL}/company?search=${search}&page=${page}&limit=${limit}&isActive=${isActive}`,
      config
    );

    dispatch({
      type: COMPANY_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: COMPANY_LIST_FAIL,
      payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message,
    });
  }
};

// Create company
export const createCompany = (companyData) => async (dispatch, getState) => {
  try {
    dispatch({ type: COMPANY_CREATE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post(
      `${API_URL}/company`,
      companyData,
      config
    );

    dispatch({
      type: COMPANY_CREATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: COMPANY_CREATE_FAIL,
      payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message,
    });
  }
};

// Get company details
export const getCompanyDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: COMPANY_DETAILS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`${API_URL}/company/${id}`, config);

    dispatch({
      type: COMPANY_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: COMPANY_DETAILS_FAIL,
      payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message,
    });
  }
};

// Update company
export const updateCompany = (id, companyData) => async (dispatch, getState) => {
  try {
    dispatch({ type: COMPANY_UPDATE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.put(
      `${API_URL}/company/${id}`,
      companyData,
      config
    );

    dispatch({
      type: COMPANY_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: COMPANY_UPDATE_FAIL,
      payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message,
    });
  }
};

// Delete company
export const deleteCompany = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: COMPANY_DELETE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.delete(`${API_URL}/company/${id}`, config);

    dispatch({
      type: COMPANY_DELETE_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: COMPANY_DELETE_FAIL,
      payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message,
    });
  }
};

// Toggle company status
export const toggleCompanyStatus = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: COMPANY_TOGGLE_STATUS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.patch(
      `${API_URL}/company/${id}/toggle-status`,
      {},
      config
    );

    dispatch({
      type: COMPANY_TOGGLE_STATUS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: COMPANY_TOGGLE_STATUS_FAIL,
      payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message,
    });
  }
};

// Get company statistics
export const getCompanyStats = () => async (dispatch, getState) => {
  try {
    dispatch({ type: COMPANY_STATS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`${API_URL}/company/stats`, config);

    dispatch({
      type: COMPANY_STATS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: COMPANY_STATS_FAIL,
      payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message,
    });
  }
};
